// src/App.js

import React, {useState} from 'react';

import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import styled from 'styled-components';

import LandingPage from './components/LandingPage/LandingPage';
import TheMList from './components/TheMList/TheMList';
import CommunityPage from './components/CommunityPage/CommunityPage';
import Inspiration from './components/Inspiration/Inspiration';
import TheMListOpen from './components/TheMListOpen/TheMListOpen';
import BlogPage from './components/blog/BlogPage';
import RSSFeed from './components/blog/BlogRss';
import JoinPage from './components/JoinPage/JoinPage';
import About from './components/About/About';
import Events from './components/Events/Events';
import Header from './components/Header/Header';
import Footer from './components/Footer';
import LoginForm from './components/Auth/LoginForm';
import Profile from './components/Profile';
import PolicyPage from './components/PolicyPage';
import Settings from './components/Settings';
import Sitemap from './components/Sitemap';
import ContactPage from './components/ContactPage';
import MainPage from './components/Support/SupportPage';
import PrivacyPage from './components/PrivacyPage';
import PartnerPage from './components/PartnerPage';
import ApplyForm from './components/Application/Application';
import TheClubPage from './components/TheClub/TheClubPage';
import Login from './components/Login/Login';
import Chat from './components/Chat/Chat';
import CookieConsentComponent from './components/CookieConsentComponent';
import DesignOverlayGlobal from './components/devtools/DesignOverlayGlobal';
import LayoutInspectorGlobal from './components/devtools/LayoutInspectorGlobal';
import {DevtoolsStackProvider} from './components/devtools/DevtoolsStackContext';
import {DevtoolsSessionProvider} from './components/devtools/DevtoolsSessionContext';
import AdminToolsLandingPage from './components/adminTools/AdminToolsLandingPage';
import ListingsWranglerListPage from './components/adminTools/ListingsWranglerListPage';
import ListingsWranglerDetailPage from './components/adminTools/ListingsWranglerDetailPage';
import HoodieProfileWranglerListPage from './components/adminTools/HoodieProfileWranglerListPage';
import HoodieProfileWranglerDetailPage from './components/adminTools/HoodieProfileWranglerDetailPage';
import AdminToolsLoginPage from './components/adminTools/AdminToolsLoginPage';
import {ClassicSiteRoutes, CLASSIC_SITE_BASE} from './features/classicSite';
import {
    AboutPage,
    CollectivePage,
    CollectivePreviewPage,
    CollectivePreviewPageTwo,
    ContactPage as TwentyTwentysixContactPage,
    EventsPage,
    HomePage,
    HomePageV2,
    HoodieDiagnosticsPage,
    InterviewPage,
    JoinPage as TwentyTwentysixJoinPage,
    LoginPage,
    MembershipPage,
    MListPage,
    PodcastsPage,
    ProgramsPage,
    ResourceArticlePage,
    ResourcesPage,
    ReviewsPage,
    TwentytwentysixColorInventoryPage,
    TwentyTwentysixSiteLayout
} from './components/twentytwentysix';


const AppContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    min-height: 100vh;
    width: 100%;
    max-width: 1080px;
    margin: 0 auto;
`;

const TheMListContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
`;


const ContentWrapper = styled.div`
    flex: 1;
    width: 100%;
`;

const App = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(true);

    const login = () => setIsLoggedIn(true);
    const logout = () => setIsLoggedIn(false);

    return (
        <AppContainer>
            {isLoggedIn && <HeaderWrapper/>}
            <ContentWrapper>
                <div id="design-overlay-root" style={{position: 'relative'}}>
                    <Routes>
                        <Route
                            path="/chat"
                            element={
                                <PrivateRoute isAuthenticated={isLoggedIn}>
                                    <Chat onLogout={logout}/>
                                </PrivateRoute>
                            }
                        />
                        <Route path="/" element={<LandingPage/>}/>
                        <Route path="/login" element={<LoginForm login={login}/>}/>
                        <Route path="/login-test" element={<Login/>}/>
                        <Route path="/community"
                               element={isLoggedIn ? <CommunityPage logout={logout}/> : <Navigate to="/login"/>}/>
                        <Route path="/the-mlist" element={<TheMList/>}/>
                        <Route path="/inspiration" element={<Inspiration/>}/>
                        <Route path="/join" element={<JoinPage/>}/>
                        <Route path="/about" element={<About/>}/>
                        <Route path="/events" element={<Events/>}/>
                        <Route path="/profile" element={<Profile/>}/>
                        <Route path="/settings" element={<Settings/>}/>
                        <Route path="/theclub" element={<TheClubPage/>}/>
                        <Route path="/application" element={<ApplyForm/>}/>
                        <Route path="/sitemap" element={<Sitemap/>}/>
                        <Route path="/policies" element={<PolicyPage/>}/>
                        <Route path="/privacy" element={<PrivacyPage/>}/>
                        <Route path="/contact" element={<ContactPage/>}/>
                        <Route path="/support" element={<MainPage/>}/>
                        <Route path="/partner" element={<PartnerPage/>}/>
                        <Route path="/blog" element={<BlogPage/>}/>
                        <Route path="/rss" element={<RSSFeed/>}/>
                        <Route path="/feature/:id" element={<TheMListOpen/>}/>
                        <Route path="/admin-tools" element={<AdminToolsLandingPage/>}/>
                        <Route path="/admin-tools/login" element={<AdminToolsLoginPage/>}/>
                        <Route path="/admin-tools/listings" element={<ListingsWranglerListPage/>}/>
                        <Route path="/admin-tools/listings/:id" element={<ListingsWranglerDetailPage/>}/>
                        <Route path="/admin-tools/hoodies" element={<HoodieProfileWranglerListPage/>}/>
                        <Route path="/admin-tools/hoodies/:id" element={<HoodieProfileWranglerDetailPage/>}/>
                        <Route path={`${CLASSIC_SITE_BASE}/*`} element={<ClassicSiteRoutes/>}/>
                        <Route path="/twentytwentysix" element={<TwentyTwentysixSiteLayout/>}>
                            <Route index element={<HomePage/>}/>
                            <Route path="home-v2" element={<HomePageV2/>}/>
                            <Route path="about" element={<AboutPage/>}/>
                            <Route path="collective" element={<CollectivePage/>}/>
                            <Route path="login" element={<LoginPage/>}/>
                            <Route path="resources" element={<ResourcesPage/>}/>
                            <Route path="resources/:slug" element={<ResourceArticlePage/>}/>
                            <Route path="events" element={<EventsPage/>}/>
                            <Route path="podcasts" element={<PodcastsPage/>}/>
                            <Route path="membership" element={<MembershipPage/>}/>
                            <Route path="join" element={<TwentyTwentysixJoinPage/>}/>
                            <Route path="programs" element={<ProgramsPage/>}/>
                            <Route path="mlist" element={<MListPage/>}/>
                            <Route path="reviews" element={<ReviewsPage/>}/>
                            <Route path="contact" element={<TwentyTwentysixContactPage/>}/>
                            <Route path="interview" element={<InterviewPage/>}/>
                            <Route path="diagnostics" element={<HoodieDiagnosticsPage/>}/>
                            <Route path="design-preview" element={<CollectivePreviewPage/>}/>
                            <Route path="design-preview-2" element={<CollectivePreviewPageTwo/>}/>
                            <Route path="color-inventory" element={<TwentytwentysixColorInventoryPage/>}/>
                        </Route>
                    </Routes>
                </div>
            </ContentWrapper>
            {isLoggedIn && <FooterWrapper/>}
            <DevtoolsSessionProvider>
                <DevtoolsStackProvider>
                    <DesignOverlayGlobal/>
                    <LayoutInspectorGlobal/>
                </DevtoolsStackProvider>
            </DevtoolsSessionProvider>
            <CookieConsentComponent/>
        </AppContainer>
    );
};

const isIsolatedSitePreview = (pathname) =>
    pathname === '/twentytwentysix' ||
    pathname.startsWith('/twentytwentysix/') ||
    pathname === CLASSIC_SITE_BASE ||
    pathname.startsWith(`${CLASSIC_SITE_BASE}/`);

const HeaderWrapper = () => {
    const location = useLocation();
    return location.pathname !== '/login' && !isIsolatedSitePreview(location.pathname) ?
        <Header currentPage={location.pathname}/> : null;
};

const FooterWrapper = () => {
    const location = useLocation();
    return location.pathname !== '/login' && !isIsolatedSitePreview(location.pathname) ?
        <Footer currentPage={location.pathname}/> : null;
};

const PrivateRoute = ({children, isAuthenticated}) => {
    return isAuthenticated ? children : <Navigate to="/login"/>;
};
export default App;
